// extracted by mini-css-extract-plugin
module.exports = {"actionBtn":"LogoutModal_actionBtn__3TLmL","text":"LogoutModal_text__1MDD6"};